var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "search_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 11 11"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".search_svg__st0{fill:none;stroke:#10181c;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search_svg__Icon_-_Search_Sm",
    transform: "translate(.401 .401)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "search_svg__Ellipse_155",
    cx: 3.6,
    cy: 3.6,
    r: 3.1,
    className: "search_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "search_svg__Line_346",
    d: "M5.9 5.8l3.4 3.5",
    className: "search_svg__st0"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIGlkPSJMYXllcl8xIiB4PSIwIiB5PSIwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMSAxMSIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgMTEgMTEiPjxzdHlsZT4uc3Qwe2ZpbGw6bm9uZTtzdHJva2U6IzEwMTgxYztzdHJva2Utd2lkdGg6MS41O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZH08L3N0eWxlPjxnIGlkPSJJY29uXy1fU2VhcmNoX1NtIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSguNDAxIC40MDEpIj48Y2lyY2xlIGlkPSJFbGxpcHNlXzE1NSIgY3g9IjMuNiIgY3k9IjMuNiIgcj0iMy4xIiBjbGFzcz0ic3QwIi8+PHBhdGggaWQ9IkxpbmVfMzQ2IiBkPSJtNS45IDUuOCAzLjQgMy41IiBjbGFzcz0ic3QwIi8+PC9nPjwvc3ZnPg==";
export { SvgSearch as ReactComponent };